import React from 'react';
import ProfilePageContent from '../components/profile/ProfilePageContent';

const ProfilePage = () => (
  <ProfilePageContent
    showFaceLogin
    breadcrumbs={[
      { label: 'Home', path: '/onboarding/landing/' },
      { label: 'Profile' },
    ]}
  />
);

export default ProfilePage;
